module.exports = __webpack_public_path__ + "img/team_1.39b897a0.png";